import type { Action, Dispatch } from 'redux'

import type { CrawlerJobId, GenericAction } from '@/types'

export enum CrawlerActions {
  SET_STARTED_JOB = 'CrawlerActions: SET_STARTED_JOB',
  SET_FINISHED_JOB = 'CrawlerActions: SET_FINISHED_JOB',
}

export type SetStartedJob = GenericAction<
  CrawlerActions.SET_STARTED_JOB,
  CrawlerJobId
>

export type SetFinishedJob = GenericAction<
  CrawlerActions.SET_FINISHED_JOB,
  CrawlerJobId
>

export const setActiveCrawlerJob =
  (jobId: CrawlerJobId | null) => (dispatch: Dispatch<Action>) => {
    dispatch({
      type: CrawlerActions.SET_STARTED_JOB,
      payload: jobId,
    })
  }

export const setFinishedCrawlerJob =
  (jobId?: CrawlerJobId | null) => (dispatch: Dispatch<Action>) => {
    dispatch({
      type: CrawlerActions.SET_FINISHED_JOB,
      payload: jobId,
    })
  }

export type CrawlerActionsType = SetStartedJob | SetFinishedJob
